import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39016b60")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconPlatte = _resolveComponent("IconPlatte")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_component_Button, { class: "color-btn" }, {
    default: _withId(() => [
      _createVNode("div", {
        class: "color-block",
        style: { backgroundColor: $props.color }
      }, null, 4),
      _createVNode(_component_IconPlatte, { class: "color-btn-icon" })
    ]),
    _: 1
  }))
})